export const APMPaymentMethodName = "APM";
